/**
 * UserAvatar - 统一的用户头像组件
 * 有头像时显示头像，无头像时显示渐变背景 + 用户名首字母
 */

import React from 'react';

// 高级灰配色方案（不太艳丽的渐变色）
const AVATAR_GRADIENTS = [
  'linear-gradient(135deg, #667eea, #764ba2)', // 蓝紫
  'linear-gradient(135deg, #6b8dd6, #8e68f3)', // 浅蓝紫
  'linear-gradient(135deg, #84a0bb, #a881cc)', // 灰蓝紫
  'linear-gradient(135deg, #7b8a9c, #8892b0)', // 灰蓝
  'linear-gradient(135deg, #8b9a9f, #a0a7b5)', // 中性灰
  'linear-gradient(135deg, #7a8e99, #90a1ac)', // 青灰
  'linear-gradient(135deg, #94a3b8, #9ca3af)', // 浅灰
  'linear-gradient(135deg, #78909c, #8897a8)', // 冷灰
];

// 根据字符串生成哈希值（简单哈希算法）
function hashString(str) {
  let hash = 0;
  if (!str) return hash;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // 转换为32位整数
  }
  return Math.abs(hash);
}

/**
 * UserAvatar 组件
 * @param {string} avatar - 头像 URL
 * @param {string} username - 用户名
 * @param {number} size - 头像尺寸，默认 32
 * @param {number} fontSize - 字体大小，默认 14
 * @param {string} border - 边框样式，默认无
 * @param {object} style - 额外的样式
 */
export default function UserAvatar({ 
  avatar, 
  username = '?', 
  size = 32, 
  fontSize = 14,
  border = 'none',
  style = {}
}) {
  // 根据用户名选择渐变色
  const gradientIndex = hashString(username) % AVATAR_GRADIENTS.length;
  const gradient = AVATAR_GRADIENTS[gradientIndex];
  
  // 获取首字母（支持中英文）
  const initial = username?.charAt(0)?.toUpperCase() || '?';
  
  return (
    <div style={{ 
      width: size, 
      height: size, 
      borderRadius: '50%', 
      position: 'relative', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      border: border,
      overflow: 'hidden',
      ...style
    }}>
      {/* 如果有头像，显示头像图片 */}
      {avatar && (
        <img
          src={avatar}
          alt={username}
          style={{
            width: '100%', 
            height: '100%', 
            borderRadius: '50%',
            objectFit: 'cover', 
            position: 'absolute',
            zIndex: 2
          }}
          onError={(e) => {
            // 头像加载失败时隐藏图片，显示下面的渐变背景
            e.target.style.display = 'none';
          }}
        />
      )}
      
      {/* 渐变背景 + 首字母（作为后备显示） */}
      <div style={{
        width: '100%', 
        height: '100%', 
        borderRadius: '50%',
        background: gradient,
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        color: '#fff', 
        fontSize: fontSize, 
        fontWeight: 600,
        position: 'absolute',
        zIndex: 1
      }}>
        {initial}
      </div>
    </div>
  );
}
